import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { getTableItems } from "../../helpers";

const PER_PAGE = 10;

export default function Paginate({ data, head }) {
  const [currentPage, setCurrentPage] = useState(0);

  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage);
  }

  const offset = currentPage * PER_PAGE;

  const currentPageData = data
    .slice(offset, offset + PER_PAGE)
    .map((item) => getTableItems("work_weeks", item));

  const pageCount = Math.ceil(data.length / PER_PAGE);

  return (
    <>
      <table class="table checklist-table remove-space inventory_table">
        <thead>{head}</thead>
        <tbody>{currentPageData}</tbody>
      </table>

      <ReactPaginate
        previousLabel={"<"}
        nextLabel={">"}
        pageCount={pageCount}
        onPageChange={handlePageClick}
        containerClassName={"paginate"}
        previousLinkClassName={"paginate__link"}
        nextLinkClassName={"paginate__link"}
        disabledClassName={"paginate__link--disabled"}
        activeClassName={"paginate__link--active"}
      />
    </>
  );
}
